import { createModule } from 'saga-slice';
import { takeLatest } from 'redux-saga/effects';
import { sagaApi } from '#/apis';
import { crudReducers, noop, updateSuccess } from 'saga-slice-helpers';
import Swal from '#/swal';
import history from '#/history';

const sagaSlice = createModule({

    name: 'evals',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: crudReducers({

        generate: noop,
        generateSuccess: noop,
        generateFail: noop,

        batchDelete: noop,
        batchDeleteSuccess: noop,
        batchDeleteFail: noop,

        batchFreeze: noop,
        batchFreezeSuccess: noop,
        batchFreezeFail: noop,

        batchUnfreeze: noop,
        batchUnfreezeSuccess: noop,
        batchUnfreezeFail: noop,

        customUpdateSuccess: updateSuccess

    }),

    // eslint-disable-next-line max-lines-per-function
    sagas: A => ({
        [A.create]: {
            *saga ({ payload }) {
                const {
                    employeeId
                } = payload;

                delete payload.department_id;
                delete payload.employeeId;

                yield sagaApi.post(
                    `/employees/${employeeId}/evals`,
                    payload,
                    A.createSuccess,
                    A.createFail
                );
            }
        },
        [A.delete]: {
            *saga ({ payload }) {
                const {
                    department_id, eval_id
                } = payload;

                yield sagaApi.delete(
                    `/departments/${department_id}/evals/${eval_id}`,
                    null,
                    A.deleteSuccess,
                    A.deleteFail
                );
            }
        },
        [A.deleteSuccess]: {
            *saga () {

                yield Swal.fire.success();
            }
        },
        [A.batchFreeze]: {
            *saga ({ payload }) {
                const { department_id } = payload;
                delete payload.department_id;

                yield sagaApi.post(
                    `/departments/${department_id}/evals/freeze-batch`,
                    payload,
                    A.batchFreezeSuccess,
                    A.batchFreezeFail
                );
            }
        },
        [A.batchUnfreeze]: {
            *saga ({ payload }) {
                const { department_id } = payload;
                delete payload.department_id;

                yield sagaApi.post(
                    `/departments/${department_id}/evals/unfreeze-batch`,
                    payload,
                    A.batchUnfreezeSuccess,
                    A.batchUnfreezeFail
                );
            }
        },
        [A.batchUnfreezeSuccess]: function* () {
            yield Swal.fire.success();
        },
        [A.batchFreezeSuccess]: function* () {
            yield Swal.fire.success();
        },
        [A.batchDelete]: {
            *saga ({ payload }) {
                const { department_id } = payload;
                delete payload.department_id;

                yield sagaApi.post(
                    `/departments/${department_id}/evals/delete-batch`,
                    payload,
                    A.batchDeleteSuccess,
                    A.batchDeleteFail
                );
            }
        },
        [A.batchDeleteSuccess]: {
            *saga ({ payload }) {
                yield history.push('/evals');
                yield Swal.fire.success();
            }
        },
        [A.update]: {
            *saga ({ payload }) {

                const {
                    employee, id, ...restPayload
                } = payload;
                yield sagaApi.put(
                    `/employees/${employee.id}/evals/${id}`,
                    restPayload,
                    A.customUpdateSuccess,
                    A.readOneFail
                );
            }
        },
        [A.readOne]: {
            *saga ({ payload }) {
                const {
                    eval_id, employee_id
                } = payload;
                yield sagaApi.get(
                    `/employees/${employee_id}/evals/${eval_id}`,
                    A.readOneSuccess,
                    A.readOneFail
                );
            },
            taker: takeLatest
        },
        [A.readAll]: {
            *saga ({ payload: department_id }) {

                yield sagaApi.get(
                    `/departments/${department_id}/evals`,
                    A.readAllSuccess,
                    A.readAllFail
                );
            },
            taker: takeLatest
        },
        [A.generate]: {
            *saga ({ payload }) {

                if (payload.ids === null) {
                    delete payload.ids;
                }

                yield sagaApi.post(
                    '/evals/generate',
                    payload,
                    A.generateSuccess,
                    A.generateFail
                );
            },
            taker: takeLatest
        },
        [A.generateSuccess]: {
            *saga () {
                yield Swal.fire.success();
            }
        },
        [A.customUpdateSuccess]: function*() {
            yield Swal.fire({
                toast: true,
                position: 'bottom',
                timer: 3000,
                timerProgressBar: true,
                icon: 'success',
                title: 'Eval Saved',
                showConfirmButton: false
            });

        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
